export default Object.freeze({
  EvaluacionInicial: 1,
  EvaluacionAdicional: 2,
  Terapia: 3,
  Consultoria: 7,
  EducationalService: 8,
});
